/**
 * Checks if a mouse event has a modifier, based on:
 *  - macOS: metaKey (command)
 *  - windows/others: ctrlKey (control)
 * These keys modify the default mouse behavior, for example: an anchor
 * tag opens the link in a new tab, instead of changing the current tab's
 * history (if target="_blank" isn't set).
 */
export const hasModifier = (e: React.MouseEvent) => e.metaKey || e.ctrlKey;

/**
 * Wrapper function to  stop the propagation and default behavior of a
 * mouse event. Useful to avoid defining this for each component where
 * this is required to do.
 */
export const stopEffects = (callback?: () => any) => (e?: React.MouseEvent) => {
  e?.preventDefault();
  e?.stopPropagation();

  if (e) {
    e.bubbles = false;
  }

  if (callback) {
    callback();
  }
};
